export default __webpack_public_path__ + "static/media/profile-pic.ce826c5b.png";